
import React, { useContext, useEffect, useState } from "react";
import { Navbar, Container, Button, Image, Modal, Form } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import axios from "../context/AxiosInstance";
import { toast } from "react-toastify";
import "../styles/navbar.css";
import { FaUser, FaEdit, FaTrash } from 'react-icons/fa';
import logoAGUIPEX from "../assets/aguipex_anime.png"; // ⚠️ Mets ton logo animé ici
import userAvatar from "../assets/gif.png"; // ⚠️ Mets un avatar par défaut ici

const AppNavbar = () => {
  const { userInfo, logout } = useContext(AuthContext);
  const [horloge, setHorloge] = useState(new Date());
  const [showPwd, setShowPwd] = useState(false);
  const [pwdData, setPwdData] = useState({ ancien: "", nouveau: "", confirmer: "" });
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => setHorloge(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleLogout = () => {
    logout();
    toast.info("Déconnexion réussie 👋");
  };

  const canChangePassword = ["ADMIN", "RH", "ASSISTANT"].includes((userInfo?.type_compte || "").toUpperCase());

  const submitPassword = async () => {
    if (pwdData.nouveau !== pwdData.confirmer) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    try {
      const roleUpper = (userInfo?.type_compte || '').toUpperCase();
      const url = roleUpper === 'PERSONNEL' ? '/personnel/changer-mot-de-passe/' : '/utilisateurs/mon-mot-de-passe';
      await axios.post(url, { ancien_mot_de_passe: pwdData.ancien, nouveau_mot_de_passe: pwdData.nouveau });
      toast.success("Mot de passe modifié");
      setShowPwd(false);
      setPwdData({ ancien: "", nouveau: "", confirmer: "" });
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.response?.data?.message || "Erreur lors du changement de mot de passe";
      toast.error(msg);
    }
  };

  const formatDate = (date) => {
    return date.toLocaleString("fr-FR", {
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const toggleSidebar = () => {
    const body = document.body;
    if (body.classList.contains('sidebar-open')) {
      body.classList.remove('sidebar-open');
    } else {
      body.classList.add('sidebar-open');
    }
  };

  return (
    <Navbar className="custom-navbar shadow-sm px-3 px-lg-4" expand="lg">
      <Container fluid className="justify-content-between align-items-center">
        {/* Left: burger + logo + horloge */}
        <div className="d-flex align-items-center gap-2 gap-lg-3">
          <Button variant="outline-light" size="sm" className="d-lg-none" onClick={toggleSidebar} aria-label="Ouvrir le menu">
            ☰
          </Button>
          <img src={logoAGUIPEX} alt="Logo" height="45" className="logo-anim" />
          <span className="horloge">{formatDate(horloge)}</span>
        </div>

        {/* Utilisateur connecté + avatar */}
        <div className="d-flex align-items-center gap-2 gap-lg-3">
          <span className="fw-semibold text-dark">
            Bienvenue, {userInfo?.prenom || "Utilisateur"} 👋
          </span>
          <Image
            src={userAvatar}
            alt="Avatar"
            roundedCircle
            height={36}
            style={{ border: "2px solid #ccc" }}
          />
          {canChangePassword && (
            <Button variant="outline-secondary" size="sm" onClick={() => setShowPwd(true)} className="me-1">
              Changer mot de passe
            </Button>
          )}
          <Button variant="outline-danger" size="sm" onClick={handleLogout}>
            Déconnexion
          </Button>
        </div>
      </Container>
      <Modal show={showPwd} onHide={() => setShowPwd(false)} centered>
        <Modal.Header closeButton><Modal.Title>Changer mon mot de passe</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Ancien mot de passe</Form.Label>
              <div className="input-group">
                <Form.Control type={showOld ? "text" : "password"} value={pwdData.ancien} onChange={(e) => setPwdData({ ...pwdData, ancien: e.target.value })} />
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowOld(v => !v)}>{showOld ? "Cacher" : "Afficher"}</button>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nouveau mot de passe</Form.Label>
              <div className="input-group">
                <Form.Control type={showNew ? "text" : "password"} value={pwdData.nouveau} onChange={(e) => setPwdData({ ...pwdData, nouveau: e.target.value })} />
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowNew(v => !v)}>{showNew ? "Cacher" : "Afficher"}</button>
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirmer le nouveau mot de passe</Form.Label>
              <div className="input-group">
                <Form.Control type={showConfirm ? "text" : "password"} value={pwdData.confirmer} onChange={(e) => setPwdData({ ...pwdData, confirmer: e.target.value })} />
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowConfirm(v => !v)}>{showConfirm ? "Cacher" : "Afficher"}</button>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPwd(false)}>Annuler</Button>
          <Button variant="primary" onClick={submitPassword}>Enregistrer</Button>
        </Modal.Footer>
      </Modal>
    </Navbar>
  );
};

export default AppNavbar;
